import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
import Graphic from "@arcgis/core/Graphic";
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MapserviceService {

  token = "";
  private viewSource = new BehaviorSubject<[]>(null);
  private webMapIDSource = new BehaviorSubject<string>(null);

  private userNameSource = new BehaviorSubject<string>(null);

  private studiesFeatureTableSource = new BehaviorSubject<any>(null);
  private elevationsFeatureTableSource = new BehaviorSubject<any>(null);

  studieslayer = new FeatureLayer({
    url: environment.studiesTableUrl
  });

  elevationlayer = new FeatureLayer({
    url: environment.elevationsTableUrl
  });

  view = this.viewSource.asObservable();
  webMapID = this.webMapIDSource.asObservable();
  studiesFeatureTable = this.studiesFeatureTableSource.asObservable();
  elevationsFeatureTable = this.elevationsFeatureTableSource.asObservable();

  userName = this.userNameSource.asObservable();

  constructor(private http: HttpClient) {}

  changeView(view: any) {
    this.viewSource.next(view);
  }

  updateStudiesFeatureTable(featureTable: any) {
    this.studiesFeatureTableSource.next(featureTable);
  }

  updateElevationsFeatureTable(featureTable: any) {
    this.elevationsFeatureTableSource.next(featureTable);
  }

  updateUsername(username: string) {
    this.userNameSource.next(username);
  }

  updateID() {
    const url =
      `${environment.studiesTableUrl}/query?` +
      `outStatistics=%5B%7B%22statisticType%22%3A%22max%22%2C` +
      `%22onStatisticField%22%3A%22fs_id%22%2C` +
      `%22outStatisticFieldName%22%3A%22max_id%22%7D%5D&` +
      `returnGeometry=false&f=json`;
      // `&token=` + this.token;

    return this.http.get(url);
  }

  queryLakeName(id: string) {
    const url =
      `${environment.basinsLayerUrl}/query?` +
      `where=dowlknum%3D%27${id}%27&` +
      `outFields=dowlknum%2Cpw_basin_name&` +
      `returnGeometry=false&f=json` +
      `&token=` + this.token;

    return this.http.get(url);
  }

  postStudy(studyName, studyRemarks, studyDate, fsID, verticalDatum, sourceType) {
    const attributes = {
      study_name: studyName,
      study_remark: studyRemarks,
      study_date: studyDate?.toLocaleDateString(),
      fs_id: fsID,
      vertical_datum: verticalDatum,
      source_type: sourceType
    };

    const addFeature = new Graphic({ attributes });
    return this.studieslayer.applyEdits({ addFeatures: [addFeature] });
  }

  deleteStudy(objectid) {
    return this.studieslayer.applyEdits({
      deleteFeatures: [{ objectId: objectid }]
    });
  }

  postElevation(
    lakeID,
    basinName,
    fsID,
    tenYearNumber,
    tenYearComments,
    twentyFiveYearNumber,
    twentyFiveYearComments,
    fiftyYearNumber,
    fiftyYearComments,
    oneHundredYearNumber,
    oneHundredYearComments,
    fiveHundredYearNumber,
    fiveHundredYearComments
  ) {
    const attributes = {
      dowlknum: lakeID,
      pw_basin_name: basinName,
      fs_id: fsID,
      elevation_feet_10_year_flood: tenYearNumber,
      f10_yr_comment: tenYearComments,
      elevation_feet_25_year_flood: twentyFiveYearNumber,
      f25_yr_comment: twentyFiveYearComments,
      elevation_feet_50_year_flood: fiftyYearNumber,
      f50_yr_comment: fiftyYearComments,
      elevation_feet_100_year_flood: oneHundredYearNumber,
      f100_yr_comment: oneHundredYearComments,
      elevation_feet_500_year_flood: fiveHundredYearNumber,
      f500_yr_comment: fiveHundredYearComments
    };

    const addFeature = new Graphic({ attributes });
    return this.elevationlayer.applyEdits({ addFeatures: [addFeature] });
  }

  deleteElevations(objectid) {
    return this.elevationlayer.applyEdits({
      deleteFeatures: [{ objectId: objectid }]
    });
  }
}
